var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showmodal
    ? _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "modal fade show",
              staticStyle: { display: "block" },
              attrs: { tabindex: "-1" },
            },
            [
              _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c(
                    "div",
                    { staticClass: "modal-header justify-content-center" },
                    [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Billing details"),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.closeModal },
                        },
                        [_c("span", [_vm._v("×")])]
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "container-comm" }, [
                        _c("div", { staticClass: "container-comm" }, [
                          _c("input", {
                            staticClass: "form-control",
                            attrs: { type: "text", disabled: "" },
                            domProps: { value: _vm.BillingData.service_name },
                          }),
                          _vm._m(0),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "container-comm" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.editableAmount,
                              expression: "editableAmount",
                            },
                          ],
                          staticClass: "form-control",
                          class: { "error-msg-hold": _vm.isAmountValid },
                          attrs: { type: "text" },
                          domProps: { value: _vm.editableAmount },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.editableAmount = $event.target.value
                              },
                              _vm.onAmountInput,
                            ],
                          },
                        }),
                        _c("label", { attrs: { for: "pname" } }, [
                          _c("b", [
                            _vm._v("Amount (" + _vm._s(_vm.currency) + ")"),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "self-hold" }, [
                        _c(
                          "div",
                          {
                            staticClass: "select",
                            class: { "error-msg-hold": _vm.ispaymentValid },
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.paymentmode,
                                    expression: "paymentmode",
                                  },
                                ],
                                staticClass: "select-text",
                                attrs: { required: "" },
                                on: {
                                  change: function ($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call(
                                        $event.target.options,
                                        function (o) {
                                          return o.selected
                                        }
                                      )
                                      .map(function (o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.paymentmode = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                },
                              },
                              [
                                _c("option", {
                                  attrs: {
                                    value: "",
                                    disabled: "",
                                    selected: "",
                                  },
                                }),
                                _c("option", { attrs: { value: "cash" } }, [
                                  _vm._v(
                                    "\n                    Cash\n                  "
                                  ),
                                ]),
                                _c("option", { attrs: { value: "upi" } }, [
                                  _vm._v(
                                    "\n                    UPI\n                  "
                                  ),
                                ]),
                              ]
                            ),
                            _c("span", { staticClass: "select-highlight" }),
                            _c("span", { staticClass: "select-bar" }),
                            _c("label", { staticClass: "select-label" }, [
                              _vm._v(_vm._s(_vm.$t("PaymentMode"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "primary-btn",
                        class: { "global-disabled": _vm.disablesave },
                        attrs: { disabled: _vm.disablesave },
                        on: { click: _vm.submitBilling },
                      },
                      [_vm._v("\n            Save\n          ")]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "quick-billing view-invoice",
                        class: { "global-disabled": _vm.disableinvoicereceipt },
                        staticStyle: { "padding-left": "10px" },
                        attrs: {
                          href: "javascript:void(0)",
                          "data-toggle": "tooltip",
                          "data-placement": "top",
                          title: "View Invoice",
                        },
                        on: {
                          click: function ($event) {
                            !_vm.disableinvoicereceipt && _vm.getviewinvoice()
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/static/images/invoice-black.png"),
                          },
                        }),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "quick-billing view-receipt",
                        class: { "global-disabled": _vm.disableinvoicereceipt },
                        staticStyle: { "padding-left": "10px" },
                        attrs: {
                          href: "javascript:void(0)",
                          "data-toggle": "tooltip",
                          "data-placement": "top",
                          title: "View Receipt",
                        },
                        on: {
                          click: function ($event) {
                            !_vm.disableinvoicereceipt && _vm.getviewreceipt()
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/static/images/receipt-black.png"),
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm.showspinner ? _c("div", [_vm._m(1)]) : _vm._e(),
                ]),
              ]),
            ]
          ),
          _c("div", { staticClass: "modal-backdrop fade show" }),
          _vm.showinvoice
            ? _c(
                "div",
                [
                  _c("InvoicePopup", {
                    attrs: { appointmentid: _vm.appt_id },
                    on: {
                      closeinvoice: function ($event) {
                        return _vm.closeinvoicepopup()
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.showreceipt
            ? _c(
                "div",
                [
                  _c("ReceiptPopup", {
                    attrs: { appointmentid: _vm.appt_id },
                    on: {
                      closereceipt: function ($event) {
                        return _vm.closereceiptpopup()
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.isdisplaymsg
                ? _c("Messages", {
                    attrs: {
                      datamessage: _vm.sucessmsgtext,
                      iserror: _vm.iserrormsg,
                      isVisible: _vm.isdisplaymsg,
                    },
                    on: { closemsg: _vm.closeMessage },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "pname" } }, [
      _c("b", [_vm._v("Service name")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "processing_popup full-spinner",
        staticStyle: { visibility: "visible" },
      },
      [
        _c("div", { staticClass: "spinner" }, [
          _c("div", { staticClass: "bounce1" }),
          _c("div", { staticClass: "bounce2" }),
          _c("div", { staticClass: "bounce3" }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }